import { SearchFilterDTO, MultiTextFilterDTO, MultiTextSearchFilterId } from "../..";

const textSearchTypes: Record<MultiTextSearchFilterId, true> = {
  "zone-codes-id": true,
  "planning-applications-multi-text-filter-id": true,
};

export function isMultiTextSearchDTO(filter: SearchFilterDTO): filter is MultiTextFilterDTO {
  return filter.id in textSearchTypes;
}
